// The message out of a failed API call, as a STRING, always.
//
// WHY THIS EXISTS. Every lambda answers a failure with `{ error: { message } }` (buildErrorResponse in
// the util layer), so `response.data.error` is an OBJECT. Three screens read that field and put it
// straight into state, and React does not render an object: the page dies with
//
//   Objects are not valid as a React child (found: object with keys {message})
//
// which names neither the call that failed nor the screen it happened on. The fix is one line in three
// places, which is exactly the kind of thing that drifts — so it is one function instead.
//
// ORDER MATTERS. The server's own words first, because they say what was actually wrong ("that x-hotelid
// is already in use"); the axios message second, which is the generic "Request failed with status code
// 409"; the caller's fallback last.
//
// ALWAYS A STRING, whatever it finds: a server that answers with a shape nobody expected must not be
// able to take a screen down.
export const apiErrorMessage = (err, fallback = 'Something went wrong') => {
    const data = err?.response?.data;
    const candidates = [
        data?.error?.message,   // { error: { message } } — every lambda in this repo
        data?.message,          // { message } — API Gateway's own 401/403
        typeof data?.error === 'string' ? data.error : null,
        err?.message,           // axios
    ];
    for (const c of candidates) {
        if (typeof c === 'string' && c.trim()) return c;
    }
    return fallback;
};

export default apiErrorMessage;
